import { type Actions, ActionType } from './business-indicators.actions';
import { businessIndicatorAdapter, initialState, type State } from './business-indicators.state';

export function businessIndicatorsReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return { ...initialState };
        }

        case ActionType.FETCH_BUSINESS_INDICATORS: {
            return {
                ...state,
                isPending: true,
                error: null
            };
        }

        case ActionType.FETCH_BUSINESS_INDICATORS_SUCCEEDED: {
            return businessIndicatorAdapter.setAll(action.payload.businessIndicators, {
                ...state,
                isPending: false,
                isLoaded: true
            });
        }

        case ActionType.FETCH_BUSINESS_INDICATORS_FAILED: {
            return {
                ...state,
                isPending: false,
                error: action.payload.error
            };
        }

        case ActionType.CREATE_BUSINESS_INDICATOR: {
            return businessIndicatorAdapter.addOne(action.payload.businessIndicator, state);
        }

        case ActionType.UPDATE_BUSINESS_INDICATOR: {
            return businessIndicatorAdapter.updateOne(
                {
                    id: action.payload.businessIndicatorId,
                    changes: action.payload.businessIndicator
                },
                state
            );
        }

        case ActionType.DELETE_BUSINESS_INDICATOR: {
            return businessIndicatorAdapter.removeOne(action.payload.businessIndicatorId, state);
        }

        case ActionType.ADD_BUSINESS_INDICATOR_DEADLINE: {
            return businessIndicatorAdapter.updateOne(
                {
                    id: action.payload.businessIndicatorId,
                    changes: {
                        deadlineYears: [
                            ...(state.entities[action.payload.businessIndicatorId]?.deadlineYears ?? []),
                            action.payload.newDeadline
                        ]
                    }
                },
                state
            );
        }

        case ActionType.DELETE_BUSINESS_INDICATOR_DEADLINE: {
            return businessIndicatorAdapter.updateOne(
                {
                    id: action.payload.businessIndicatorId,
                    changes: {
                        deadlineYears: [
                            ...(state.entities[action.payload.businessIndicatorId]?.deadlineYears ?? []).filter(
                                deadline => deadline !== action.payload.deadlineToRemove
                            )
                        ]
                    }
                },
                state
            );
        }

        default:
            return state;
    }
}
